import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTimeSheet } from "../../Config/TimeSheetContext";
import APILIST from "../../Config/ApiList";
import AxiosInstance from "../../Config/AxiosInstance";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import YearPicker from "../../Components/YearPicker/YearPicker";
import dayjs from "dayjs";
import Ranking from "../../Utils/Ranking.json";
import Lottie from "lottie-react";
import { Circles } from "react-loader-spinner";
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
const LeaderBoard = () => {
  const { timeSheetUserDetails, isLoading } = useTimeSheet();
  const [leaderBoardList, setLeaderBoardList] = useState([]);
  const [leaderShipData, setLeaderShipData] = useState([]);
  const [isLead, setIsLoad] = useState(true);
  const navigate = useNavigate();
  const [seletedMonthYear, setSelectedMonthYear] = React.useState(dayjs().format('YYYY-MM'));
  useEffect(() => {
    if (timeSheetUserDetails?.Company_details[0]?.id) {
      getLeaderBoardList(timeSheetUserDetails?.Company_details[0]?.id, seletedMonthYear);
    }
  }, [timeSheetUserDetails?.Company_details[0]?.id, seletedMonthYear])
  const getLeaderBoardList = async (id, seletedMonthYear) => {
    setIsLoad(true);
    try {
      const selectedDate = dayjs(seletedMonthYear, 'YYYY-MM');
      const startDate = selectedDate.startOf('month').format('YYYY-MM-DD');
      const endDate = selectedDate.endOf('month').format('YYYY-MM-DD');
      const [response] = await Promise.all([
        AxiosInstance.get(APILIST.GET_LEADER_BOARD, {
          params: {
            company_id: id,
            lead_status: 1,
            start_date: startDate,
            end_date: endDate,
          }
        }),
        new Promise((resolve) => setTimeout(resolve, 3000)),
      ]);
      if (response && response?.data?.s) {
        setLeaderBoardList(response?.data?.r);
        setIsLoad(false);
      } else {
        setLeaderBoardList([]);
        setIsLoad(false);
      }
    } catch (error) {
      console.log('error', error);
      setIsLoad(false);
    }
  }
  useEffect(() => {
    if (leaderBoardList.length > 0) {
      const sortedLeaderBoard = [...leaderBoardList].sort((a, b) => b?.total_leads - a?.total_leads);
      setLeaderShipData(sortedLeaderBoard);
    } else {
      setLeaderShipData([]);
    }
  }, [leaderBoardList]);
  return isLoading ? (<Box sx={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: { xs: '100%' },
    minHeight: '100vh',
    background: 'rgba(13, 18, 41, 1)',
  }}>
    <Lottie
      animationData={Ranking}
      loop={true}
    />
  </Box>) : (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: { xs: "100%" },
          minHeight: "100vh",
          background: "rgba(13, 18, 41, 1)",
        }}
      >
        <Box
          sx={{
            background: "rgba(37, 42, 62, 1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "fixed",
            top: "0px",
            left: "0px",
            right: "0px",
            padding: "10px 15px",
            boxSizing: "border-box",
            zIndex: "10",
            width: "100%",
          }}
        >
          <Box
            sx={{
              width: "10%",
            }}
          >
            <IconButton
              sx={{
                width: "42px",
                height: "42px",
                borderRadius: "50%",
                background: "rgba(59, 63, 81, 1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                outline: "none",
                border: "none",
                cursor: "pointer",
                ":hover": {
                  background: "rgba(59, 63, 81, 1)",
                },
              }}
              onClick={() => navigate(-1)}
            >
              <img
                src="/back-arrow.webp"
                alt="back-arrow"
                style={{
                  width: "18px",
                  height: "18px",
                }}
              />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "auto",
              flex: 1,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "#ffffff",
                fontSize: "20px",
                fontWeight: "600",
                fontFamily: "Poppins",
                textAlign: "center",
                width: "100%",
              }}
            >
              Leader Board
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',

            }}
          >
            <IconButton onClick={() => navigate("/badge")}>
              <EmojiEventsIcon sx={{
                color: '#fff',
                fontSize: '28px',
              }} />
            </IconButton>
          </Box>
        </Box>
        {isLead && <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: { xs: "100%" },
            minHeight: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 100
          }}
        >
          <Circles
            height="80"
            width="80"
            color="#4fa94d"
            ariaLabel="circles-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </Box>}
        <Box
          sx={{
            backgroundImage: `url("/leader_board_bg.png")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            minHeight: "100vh",
            backgroundRepeat: "no-repeat",
            width: "100%",
            maxWidth: "100%",
          }}
        >
          <Box
            sx={{
              width: "100%",
              paddingTop: "70px",
              boxSizing: "border-box",
            }}
          >
            <Box sx={{}}>
              <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0px 15px",
              }}>
                <YearPicker
                  value={seletedMonthYear}
                  onChange={(newValue) => setSelectedMonthYear(newValue)}
                  placeholder="Select Month"
                  InputProps={{
                    sx: {
                      border: "none",
                      "& .MuiFormControl-root": { border: "none" },
                    },
                  }}
                  name="select_Month"
                />
                <Typography
                  variant="h6"
                  sx={{
                    color: "rgba(255, 255, 255, 1)",
                    fontSize: "14px",
                    fontWeight: "500",
                    fontFamily: "Poppins",
                  }}
                >
                  Winner Bonus : ${timeSheetUserDetails?.Company_details[0]?.lead_config?.winner_bonus}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "end",
                  justifyContent: "center",
                  padding: "90px 0px 0px 0px",
                }}
              >
                {/* ===== Secound Rank ==== */}
                <Box sx={{ width: "100px", height: '200px', position: "relative", animation: 'expandHeight 1s ease-out', }}>
                  <Box sx={{ width: "100%", height: "100%" }}>
                    <img
                      src="/rank2.png"
                      alt="rank2-img"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </Box>
                  <Box sx={{
                    position: "absolute",
                    top: { xs: "-65px", md: "-80px" },
                    left: { xs: "16px", md: "5px" },
                    width: { xs: "73px", md: "90px" },
                    height: { xs: "73px", md: "90px" },
                    borderRadius: "50%",
                    animation: 'expandHeight 1s ease-out',
                  }}>
                    {leaderShipData[1]?.profile_img ? <img
                      src={`https://api.nopapertimesheet.com/uploads/profile/${leaderShipData[1]?.profile_img}`}
                      alt="user-img"
                      style={{ width: "100%", height: "100%", borderRadius: "50%" }}
                    /> : <Typography
                      component={"span"}
                      sx={{
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: "400",
                        fontFamily: "Poppins",
                        width: { xs: "73px", md: "90px" },
                        height: { xs: "73px", md: "90px" },
                        borderRadius: "50%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'rgba(48, 53, 76, 1)'
                      }}
                    >
                      {leaderShipData?.length > 1 ? leaderShipData[1]?.f_name[0] + " " + leaderShipData[1]?.l_name[0] : 'N/A'}

                    </Typography>}
                  </Box>
                  <Box sx={{ position: "absolute", top: "25px", left: "34px", width: "30px" }}>
                    <img
                      src={'/second_rank.png'}
                      alt="user-img"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{
                      color: " rgba(13, 18, 41, 1)",
                      fontSize: "15px",
                      fontFamily: "Poppins",
                      position: "absolute",
                      textAlign: "center",
                      top: "65px",
                      padding: "10px",
                      width: "100%",
                      boxSizing: "border-box",
                      fontWeight: "500",
                      wordBreak: 'break-word'
                    }}
                    className="textAnimation"
                  >


                    {leaderShipData[1] ? (() => {
                      const nameParts = `${leaderShipData[1]?.f_name} ${leaderShipData[1]?.l_name}`.split(' ');
                      const firstName = nameParts.slice(0, 1).join(' ');
                      const lastName = nameParts.slice(1).join(' ');
                      return firstName.length + lastName?.length > 5 ? `${firstName} ${lastName.slice(0, 7)}` : `${firstName} ${lastName}`;
                    })() : 'N/A'}
                  </Typography>

                  <Typography
                    variant="h6"
                    sx={{
                      color: " rgba(13, 18, 41, 1)",
                      fontSize: "14px",
                      fontWeight: "500",
                      fontFamily: "Poppins",
                      position: "absolute",
                      textAlign: "center",
                      bottom: "15px",
                      background: "rgba(255, 255, 255, 0.45)",
                      flexDirection: "column",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "8px",
                      padding: "5px 10px",
                      boxSizing: "border-box",
                      left: "50%",
                      transform: "translateX(-50%)",
                      borderRight: "10px",
                    }}
                  >
                    <Typography
                      component={"span"}
                      sx={{
                        color: " #004242",
                        fontSize: "18px",
                        fontWeight: "600",
                        fontFamily: "Poppins",
                      }}

                    >
                      {leaderShipData[1]?.total_leads || 'N/A'}
                    </Typography>
                    <Typography
                      component={"span"}
                      sx={{
                        color: " #00000099",
                        fontSize: "14px",
                        fontWeight: "400",
                        fontFamily: "Poppins",
                      }}
                    >
                      Leads
                    </Typography>
                  </Typography>
                </Box>
                {/* ======= First Rank ====== */}
                <Box sx={{ width: "100px", height: '270px', position: "relative", animation: 'expandHeight1 1s ease-out', }}>
                  <Box sx={{ width: "100%", height: "100%" }}>
                    <img
                      src="/rank2.png"
                      alt="rank2-img"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </Box>
                  <Box sx={{
                    position: "absolute",
                    top: { xs: "-65px", md: "-76px" },
                    left: { xs: "16px", md: "5px" },
                    width: { xs: "73px", md: "90px" },
                    height: { xs: "73px", md: "90px" },
                    borderRadius: "50%",
                    animation: 'expandHeight1 1s ease-out',
                  }}>
                    {leaderShipData[0]?.profile_img ? <img
                      src={`https://api.nopapertimesheet.com/uploads/profile/${leaderShipData[0]?.profile_img}`}
                      alt="user-img"
                      style={{ width: "100%", height: "100%", borderRadius: "50%" }}
                    /> : <Typography
                      component={"span"}
                      sx={{
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: "400",
                        fontFamily: "Poppins",
                        width: { xs: "73px", md: "90px" },
                        height: { xs: "73px", md: "90px" },
                        borderRadius: "50%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'rgba(48, 53, 76, 1)'
                      }}
                    >
                      {leaderShipData?.length > 0 ? leaderShipData[0]?.f_name[0] + " " + leaderShipData[0]?.l_name[0] : 'N/A'}
                    </Typography>}
                  </Box>
                  <Box sx={{
                    position: "absolute",
                    top: "50px",
                    left: "30px",
                    width: "40px",
                  }}>
                    <img
                      src={'/first_rank.png'}
                      alt="user-img"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{
                      color: " rgba(13, 18, 41, 1)",
                      fontSize: "16px",
                      fontFamily: "Poppins",
                      position: "absolute",
                      textAlign: "center",
                      top: "110px",
                      padding: "10px",
                      width: "100%",
                      boxSizing: "border-box",
                      fontWeight: "600",
                      wordBreak: 'break-word'
                    }}
                  >

                    {leaderShipData[0] ? (() => {
                      const nameParts = `${leaderShipData[0]?.f_name} ${leaderShipData[0]?.l_name}`.split(' ');
                      const firstName = nameParts.slice(0, 1).join(' ');
                      const lastName = nameParts.slice(1).join(' ');
                      return firstName.length + lastName?.length > 5 ? `${firstName} ${lastName.slice(0, 7)}` : `${firstName} ${lastName}`;
                    })() : 'N/A'}
                  </Typography>

                  <Typography
                    variant="h6"
                    sx={{
                      color: " rgba(13, 18, 41, 1)",
                      fontSize: "14px",
                      fontWeight: "500",
                      fontFamily: "Poppins",
                      position: "absolute",
                      textAlign: "center",
                      bottom: "25px",
                      background: "rgba(255, 255, 255, 0.45)",
                      flexDirection: "column",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "8px",
                      padding: "5px 10px",
                      boxSizing: "border-box",
                      left: "50%",
                      transform: "translateX(-50%)",
                      borderRight: "10px",
                    }}
                  >
                    <Typography
                      component={"span"}
                      sx={{
                        color: " #004242",
                        fontSize: "24px",
                        fontWeight: "700",
                        fontFamily: "Poppins",
                      }}
                    >
                      {leaderShipData[0]?.total_leads || 'N/A'}
                    </Typography>
                    <Typography
                      component={"span"}
                      sx={{
                        color: " #00000099",
                        fontSize: "16px",
                        fontWeight: "400",
                        fontFamily: "Poppins",
                      }}
                    >
                      Leads
                    </Typography>
                  </Typography>
                </Box>
                {/* ======== Third Rank ======== */}
                <Box sx={{ width: "100px", height: '180px', position: "relative", animation: 'expandHeight2 1s ease-out', }}>
                  <Box sx={{ width: "100%", height: "100%" }}>
                    <img
                      src="/rank2.png"
                      alt="rank2-img"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </Box>
                  <Box sx={{
                    position: "absolute",
                    top: { xs: "-65px", md: "-78px" },
                    left: { xs: "16px", md: "5px" },
                    width: { xs: "73px", md: "90px" },
                    height: { xs: "73px", md: "90px" },
                    borderRadius: "50%",
                  }}>
                    {leaderShipData[2]?.profile_img ? <img
                      src={`https://api.nopapertimesheet.com/uploads/profile/${leaderShipData[2]?.profile_img}`}
                      alt="user-img"
                      style={{ width: "100%", height: "100%", borderRadius: "50%" }}
                    /> : <Typography
                      component={"span"}
                      sx={{
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: "400",
                        fontFamily: "Poppins",
                        width: { xs: "73px", md: "90px" },
                        height: { xs: "73px", md: "90px" },
                        borderRadius: "50%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'rgba(48, 53, 76, 1)'
                      }}
                    >
                      {leaderShipData?.length > 2 ? leaderShipData[2]?.f_name[0] + " " + leaderShipData[2]?.l_name[0] : 'N/A'}
                    </Typography>}
                  </Box>
                  <Box sx={{
                    position: "absolute",
                    top: "20px",
                    left: "34px",
                    width: "25px",
                  }}>
                    <img
                      src={'/third_rank.png'}
                      alt="user-img"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{
                      color: " rgba(13, 18, 41, 1)",
                      fontSize: "13px",
                      fontFamily: "Poppins",
                      position: "absolute",
                      textAlign: "center",
                      top: "55px",
                      padding: "10px",
                      width: "100%",
                      boxSizing: "border-box",
                      fontWeight: "500",
                      wordBreak: 'break-word'
                    }}
                  >{leaderShipData[2] ? (() => {
                    const nameParts = `${leaderShipData[2]?.f_name} ${leaderShipData[2]?.l_name}`.split(' ');
                    const firstName = nameParts.slice(0, 1).join(' ');
                    const lastName = nameParts.slice(1).join(' ');
                    return firstName.length + lastName?.length > 5 ? `${firstName} ${lastName.slice(0, 7)}` : `${firstName} ${lastName}`;
                  })() : 'N/A'}
                  </Typography>

                  <Typography
                    variant="h6"
                    sx={{
                      color: " rgba(13, 18, 41, 1)",
                      fontSize: "14px",
                      fontWeight: "500",
                      fontFamily: "Poppins",
                      position: "absolute",
                      textAlign: "center",
                      bottom: "15px",
                      background: "rgba(255, 255, 255, 0.45)",
                      flexDirection: "column",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "8px",
                      padding: "5px 10px",
                      boxSizing: "border-box",
                      left: "50%",
                      transform: "translateX(-50%)",
                      borderRight: "10px",
                    }}
                  >
                    <Typography
                      component={"span"}
                      sx={{
                        color: " #004242",
                        fontSize: "16px",
                        fontWeight: "500",
                        fontFamily: "Poppins",
                      }}
                    >
                      {leaderShipData[2]?.total_leads || 'N/A'}
                    </Typography>
                    <Typography
                      component={"span"}
                      sx={{
                        color: " #00000099",
                        fontSize: "12px",
                        fontWeight: "400",
                        fontFamily: "Poppins",
                      }}
                    >
                      Leads
                    </Typography>
                  </Typography>
                </Box>
              </Box>
              {leaderShipData?.length === 1 && (
                <marquee style={{ color: '#fff', padding: '5px 0px' }}>
                  {leaderShipData[0]?.f_name + " " + leaderShipData[0]?.l_name || 'N/A'} is in the lead right now.
                </marquee>
              )}
              {leaderShipData?.length === 2 && (
                <marquee style={{ color: '#fff', padding: '5px 0px' }}>
                  {leaderShipData[0]?.f_name + " " + leaderShipData[0]?.l_name || 'N/A'} is in the lead right now, with{" "}
                  {leaderShipData[1]?.f_name + " " + leaderShipData[1]?.l_name || 'N/A'}
                </marquee>
              )}
              {leaderShipData?.length === 3 && (
                <marquee style={{ color: '#fff', padding: '5px 0px' }}>
                  {leaderShipData[0]?.f_name + " " + leaderShipData[0]?.l_name || 'N/A'} is in the lead right now, with{" "}
                  {leaderShipData[1]?.f_name + " " + leaderShipData[1]?.l_name || 'N/A'} and{" "}
                  {leaderShipData[2]?.f_name + " " + leaderShipData[2]?.l_name || 'N/A'}
                </marquee>
              )}
            </Box>
            <Box
              sx={{
                overflowY: "auto",
                padding: "15px 15px 65px 15px",
                background: "rgba(11, 17, 45, 1)",
                borderTopLeftRadius: "25px",
                borderTopRightRadius: "25px",
                minHeight: 'calc(100vh - 527px)'
              }}
            >
              <Table
                sx={{
                  width: "100%",
                  // minHeight: 'calc(100vh - 520px)',
                  border: '0px solid red',
                  overflowY: 'scroll'
                }}
              >
                <TableHead
                  sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    background: "rgba(11, 17, 45, 1)",
                  }}
                >
                  <TableRow>
                    <TableCell
                      sx={{
                        fontWeight: "500",
                        fontSize: "15px",
                        color: "rgba(255, 255, 255, 1)",
                        fontFamily: "Poppins",
                        padding: "12px 5px"
                      }}
                    >
                      Rank
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "500",
                        fontSize: "15px",
                        color: "rgba(255, 255, 255, 1)",
                        fontFamily: "Poppins",
                        padding: "12px 5px",
                      }}
                    >
                      Badge
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "500",
                        fontSize: "15px",
                        color: "rgba(255, 255, 255, 1)",
                        fontFamily: "Poppins",
                        padding: "12px 5px",
                      }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "500",
                        fontSize: "15px",
                        color: "rgba(255, 255, 255, 1)",
                        fontFamily: "Poppins",
                        padding: "12px 5px",
                      }}
                    >
                      Leads
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {isLead ? (
                    [...Array(10)].map((_, index) => (
                      <TableRow key={index} sx={{ background: index % 2 === 0 ? "rgba(3, 76, 129, 1)" : "rgba(48, 53, 76, 1)" }}>
                        <TableCell sx={{ padding: "12px 20px" }}>
                          <Skeleton variant="text" width="50px" height="20px" />
                        </TableCell>
                        <TableCell sx={{ padding: "12px 20px" }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: '10px' }}>
                            <Skeleton variant="circular" width={35} height={35} />
                            <Skeleton variant="text" width="100px" height="20px" sx={{ marginLeft: "10px" }} />
                          </Box>
                        </TableCell>
                        <TableCell sx={{ padding: "12px 20px" }}>
                          <Skeleton variant="text" width="80px" height="20px" />
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    leaderBoardList && leaderBoardList.slice(0, 10).map((row, index) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          background: index % 2 === 0 ? "rgba(3, 76, 129, 1)" : "rgba(48, 53, 76, 1)",
                          borderRadius: "15px",
                          marginBottom: "5px",
                        }}
                      >
                        <TableCell sx={{ fontWeight: "500", fontSize: "15px", color: "rgba(255, 255, 255, 1)", fontFamily: "Poppins", padding: "12px 5px", textAlign: 'center' }}>
                          {index + 1}
                        </TableCell>
                        <TableCell sx={{ fontWeight: "500", fontSize: "15px", color: "rgba(255, 255, 255, 1)", fontFamily: "Poppins", padding: "12px 5px", width: '34px' }}>
                          <Typography
                            component={"span"}
                            sx={{
                              color: "#fff",
                              fontSize: "28px",
                              fontWeight: "400",
                              fontFamily: "Poppins",
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer'
                            }}
                            onClick={() => navigate("/badge")}
                          >
                            {row?.badge?.badge}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ fontWeight: "500", fontSize: "15px", color: "rgba(255, 255, 255, 1)", fontFamily: "Poppins", padding: "12px 5px" }}>
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gridGap: "10px", textWrap: "nowrap" }}>

                            {row?.profile_img ? (
                              <>
                                <img
                                  src={`https://api.nopapertimesheet.com/uploads/profile/${row?.profile_img}`}
                                  alt="user-image"
                                  style={{ width: "35px", height: "35px", borderRadius: "50%", objectFit: "cover" }}
                                />
                              </>) : <Typography
                                component={"span"}
                                sx={{
                                  color: "#fff",
                                  fontSize: "14px",
                                  fontWeight: "400",
                                  fontFamily: "Poppins",
                                  width: "35px", height: "35px", borderRadius: "50%",
                                  border: '1px solid #ddd',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}
                              >
                              {row?.f_name[0] + row?.l_name[0]}
                            </Typography>}
                            <Tooltip title={`${row.f_name} ${row.l_name}`} arrow>
                              <Typography
                                component={"span"}
                                sx={{
                                  color: "#fff",
                                  fontSize: "14px",
                                  fontWeight: "400",
                                  fontFamily: "Poppins",
                                  display: "inline-block",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  width: "100%",
                                  maxWidth: "calc(100% - 45px)",
                                }}
                              >
                                {`${row.f_name} ${row.l_name}`.length > 15
                                  ? `${row.f_name} ${row.l_name}`.slice(0, 20) + "..."
                                  : `${row.f_name} ${row.l_name}`}
                              </Typography>
                            </Tooltip>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ fontWeight: "500", fontSize: "15px", color: "rgba(255, 255, 255, 1)", fontFamily: "Poppins", padding: "12px 5px", textAlign: 'center' }}>
                          {row.total_leads}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>

              </Table>
            </Box>
          </Box>
        </Box>
      </Box>
    </Fragment>
  );
};

export default LeaderBoard;
